import {
  getConsentInitializationSnippet,
  getDataLayerSnippet,
  getGTMScript,
  getIframeSnippet,
} from './snippets'
import {ISendToGTM, ISetupGTM, ISnippetsParams} from './types'

const setupGTM = (params: ISnippetsParams): ISetupGTM => {
  const getConsentInitializationScript = () => {
    const consentInitializationScript = document.createElement('script')
    consentInitializationScript.innerHTML = getConsentInitializationSnippet(params.dataLayerName)
    return consentInitializationScript
  }

  const getDataLayerScript = () => {
    const dataLayerScript = document.createElement('script')
    dataLayerScript.innerHTML = getDataLayerSnippet(params.dataLayer, params.dataLayerName)
    return dataLayerScript
  }

  const getNoScript = () => {
    const noScript = document.createElement('noscript')
    noScript.innerHTML = getIframeSnippet(params.id, params.environment)
    return noScript
  }

  const getScript = () => {
    const script = document.createElement('script')
    if (params.nonce) {
      script.setAttribute('nonce', params.nonce)
    }
    script.innerHTML = getGTMScript(params.dataLayerName, params.id, params.environment)
    return script
  }

  return {
    getConsentInitializationScript,
    getDataLayerScript,
    getNoScript,
    getScript,
  }
}

export const initGtm = ({
  dataLayer,
  dataLayerName,
  environment,
  nonce,
  id,
}: ISnippetsParams): void => {
  const gtm = setupGTM({
    dataLayer,
    dataLayerName,
    environment,
    nonce,
    id,
  })

  const consentInitializationScript = gtm.getConsentInitializationScript()
  const dataLayerScript = gtm.getDataLayerScript()
  const script = gtm.getScript()
  const noScript = gtm.getNoScript()

  document.head.insertBefore(consentInitializationScript, document.head.childNodes[0])
  document.head.insertBefore(dataLayerScript, document.head.childNodes[1])
  document.head.insertBefore(script, document.head.childNodes[2])
  document.body.insertBefore(noScript, document.body.childNodes[0])
}

export const sendToGTM: ISendToGTM = ({dataLayerName, data}) => {
  if (window[dataLayerName]) {
    window[dataLayerName].push(data)
  } else {
    console.warn(`dataLayer ${dataLayerName} does not exist, GTM script has to be initialized`)
  }
}
